import React, { FC, forwardRef, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import track from 'src/utils/analytics';

type Props = {
  title: string;
  className?: string;
};

const Page: FC<Props> = forwardRef(
  ({ title, className, children }, ref: React.Ref<HTMLDivElement>) => {
    const location = useLocation();

    const sendPageViewEvent = useCallback(() => {
      track.pageview({
        page_path: location.pathname
      });
    }, [location]);

    useEffect(() => {
      sendPageViewEvent();
    }, [sendPageViewEvent]);

    return (
      <div className={className} ref={ref}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        {children}
      </div>
    );
  }
);

export default Page;
